"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { isBD } from "../../../../../../../utils/businessType.lib.js";
import { showItemNumberCheck } from "../../../../../../../utils/productTile/utils.js";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { useProductTileData } from "../../../../../../../hooks/useProductTileData/index.js";
import { productInfoContainerStyles, ProductTitle } from "./styles.js";
const COMPONENT_NAME = "ProductInfo";
const ProductInfo = ({
  productTileMaxLineNumber = 3
}) => {
  const {
    isInformative,
    normalizedData,
    translationsConfig,
    productTitleId
  } = useProductTileData();
  const { productInfoData } = normalizedData;
  const {
    // productBrand,
    productName,
    partNumber,
    replacementItemNumber,
    itemNumber
  } = productInfoData || {};
  productTileMaxLineNumber = isInformative ? productTileMaxLineNumber : 2;
  const { translations } = translationsConfig || {};
  const itemNumberText = `${translations == null ? void 0 : translations.itemprefix} ${itemNumber}`;
  const replacementItemNumberText = `${translations == null ? void 0 : translations.replacementlabel} ${replacementItemNumber}`;
  const { showReplacementItem, showItemNumber } = (translationsConfig == null ? void 0 : translationsConfig.featureControls) || {};
  const isBusinessDeliverySite = isBD() ?? false;
  const showItemNumberText = itemNumber && showItemNumberCheck(
    itemNumber,
    !!showItemNumber,
    isInformative,
    isBusinessDeliverySite
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        ...productInfoContainerStyles,
        width: "100%"
      },
      "data-testid": `${COMPONENT_NAME}_${partNumber}`,
      children: [
        productName && /* @__PURE__ */ jsx(
          ProductTitle,
          {
            component: "h3",
            id: productTitleId,
            productTileMaxLineNumber,
            uniqueId: productTitleId,
            variant: "t6",
            children: productName || ""
          }
        ),
        showItemNumberText && /* @__PURE__ */ jsx(
          Text,
          {
            color: "medium",
            uniqueId: `${COMPONENT_NAME}_${itemNumber}`,
            variant: "t6",
            children: itemNumberText
          }
        ),
        replacementItemNumber && showReplacementItem && isInformative && /* @__PURE__ */ jsx(
          Text,
          {
            uniqueId: `replacementItemNumber_${partNumber}`,
            variant: "t6",
            children: replacementItemNumberText
          }
        )
      ]
    }
  );
};
export {
  ProductInfo
};
